import React, { useState, useEffect } from "react";
import { Modal, Form, message } from "antd";
import UserMangementApis from "api/userManagement";
import {
	ModalHeader,
	ModalSubHeader,
	UserScreenOne,
	AdminPermissionsScreen,
	EmployeePermissionsScreen,
	FooterButtons,
} from "./ModalHelper";
import Utils from "./utils";
import CancelModal from "./CancelModal";
import "./styles.less";

const { LineBreak, Spinner } = Utils;

const UserModal = ({
	countryCodes,
	closeModal,
	visible,
	modalType,
	currentUser,
}) => {
	const [form] = Form.useForm();
	const [allPermissions, setAllPermissions] = useState({});
	const [headerTabKey, setHeaderTabKey] = useState("1");
	const [sideBarTabKey, setSideBarTabKey] = useState("1");
	const [isAdmin, setIsAdmin] = useState(false);

	const [types, setTypes] = useState({});
	const [adminPermissions, setAdminPermissions] = useState([]);
	const [employeePermissions, setEmployeePermissions] = useState([]);
	const [totalCountPerCategory, setTotalCountPerCategory] = useState({});
	const [loading, setLoading] = useState(true);
	const [showCancelModal, toggleCancelModal] = useState(false);
	const [buttonLoader, setButtonLoader] = useState(false);

	useEffect(() => {
		if (currentUser?.email) {
			form.setFieldsValue({
				email: currentUser.email,
				first_name: currentUser.first_name,
				last_name: currentUser.last_name,
				password: "**********",
				mobile: currentUser.mobile,
				country: currentUser?.country?.id,
			});
			setIsAdmin(currentUser.isAdmin);
		}
	}, [currentUser, form]);

	useEffect(() => {
		const id = currentUser.userId;
		UserMangementApis.getPermissions(id)
			.then((res) => {
				const data = res.data;
				const permissionsData = Utils.tranformPermissionsForModal(
					data.employeePermissions
				);
				const temp = Utils.transformToAllPermissions(data.employeePermissions);
				setTotalCountPerCategory(Utils.calCountPerCategory(temp));
				setAdminPermissions(data.adminPermissions);
				setEmployeePermissions(permissionsData);
				setAllPermissions(temp);
				setTypes(data.types);
				setLoading(false);
			})
			.catch((e) => {
				Utils.ToastError(e);
				setLoading(false);
			});
	}, [currentUser, modalType]);

	const handleHeaderTabChange = (val) => {
		setHeaderTabKey(val);
	};

	const handleSideBarTabChange = (val) => {
		setSideBarTabKey(val);
	};

	const handleToggleAccess = (value, id) => {
		const isAdmin = (id === "admin" && value) || (id === "employee" && !value);
		setIsAdmin(isAdmin);
	};

	const handlePermissionToggle = (value, data) => {
		if (data.slug.includes("grantAll_")) {
			const { newAllPermissions, newCounts } =
				Utils.getNewPermissionsDataForGrantAll(allPermissions, data, value);
			setAllPermissions(newAllPermissions);
			setTotalCountPerCategory(newCounts);
		} else {
			const { newAllPermissions, newCounts } = Utils.getNewPermissionsData(
				allPermissions,
				data,
				value
			);
			setAllPermissions(newAllPermissions);
			setTotalCountPerCategory(newCounts);
		}
	};

	const handleSubPermission = (
		values = [],
		permissionId,
		subPermissionType
	) => {
		const newData = {
			...allPermissions[permissionId],
			toggleValue: values.length
				? allPermissions[permissionId].toggleValue
				: false,
			subPermission: {
				values,
			},
		};
		if (values.includes("current_user")) {
			const { newAllPermissions, newCounts } =
				Utils.updatePermissionsForWhenCurrentUser(
					allPermissions,
					permissionId,
					newData
				);
			setAllPermissions(newAllPermissions);
			setTotalCountPerCategory(newCounts);
			return;
		}

		const newAllPermissionsData = {
			...allPermissions,
			[permissionId]: newData,
		};
		const newCounts = Utils.calCountPerCategory(newAllPermissionsData);
		setTotalCountPerCategory(newCounts);
		setAllPermissions(newAllPermissionsData);
	};

	const renderbody = () => {
		if (loading) return <Spinner />;
		if (headerTabKey === "1")
			return (
				<UserScreenOne
					isAdmin={isAdmin}
					handleToggleAccess={handleToggleAccess}
					currentUser={currentUser}
					modalType={modalType}
					countryCodes={countryCodes}
				/>
			);
		if (headerTabKey === "2" && isAdmin)
			return <AdminPermissionsScreen data={adminPermissions} types={types} />;
		if (headerTabKey === "2" && !isAdmin)
			return (
				<EmployeePermissionsScreen
					data={employeePermissions}
					handleSideBarTabChange={handleSideBarTabChange}
					types={types}
					sideBarTabKey={sideBarTabKey}
					allPermissions={allPermissions}
					handlePermissionToggle={handlePermissionToggle}
					handleSubPermission={handleSubPermission}
					totalCountPerCategory={totalCountPerCategory}
					modalType={modalType}
				/>
			);
		return null;
	};

	const handleCancelModal = () => {
		toggleCancelModal(true);
	};

	const handleCancel = () => {
		if (headerTabKey === "1") handleCancelModal();
		else if (headerTabKey === "2" && sideBarTabKey === "1")
			setHeaderTabKey("1");
		else if (headerTabKey === "2" && sideBarTabKey === "2")
			setSideBarTabKey("1");
		else if (headerTabKey === "2" && sideBarTabKey === "3")
			setSideBarTabKey("2");
	};

	const handleAction = () => {
		if (modalType === "edit" && headerTabKey === "2") handleUpdateUser();
		else if (headerTabKey === "1") {
			const isValidated = Utils.validateData(
				form.getFieldsValue(true),
				modalType
			);
			if (isValidated) setHeaderTabKey("2");
		} else if (headerTabKey === "2" && isAdmin) handleAddUser();
		else if (headerTabKey === "2" && sideBarTabKey === "1")
			setSideBarTabKey("2");
		else if (headerTabKey === "2" && sideBarTabKey === "2")
			setSideBarTabKey("3");
		else if (headerTabKey === "2" && sideBarTabKey === "3") handleAddUser();
	};

	const handleAddUser = () => {
		const isValidated = Utils.validateData(
			form.getFieldsValue(true),
			modalType
		);
		if (!isValidated) return;
		const result = Utils.getDataForNewUser(
			form.getFieldsValue(true),
			allPermissions,
			isAdmin
		);
		console.log("result:", result)
		setButtonLoader(true);

		UserMangementApis.addUser(result)
			.then((res) => {
				message.success("Invite sent");
				closeModal(true);
				setButtonLoader(false);
			})
			.catch((e) => {
				Utils.ToastError(e);
				setButtonLoader(false);
			});
	};

	const handleUpdateUser = () => {
		const isValidated = Utils.validateData(form.getFieldsValue(true));
		if (!isValidated) return;
		const result = Utils.getDataForExistingUser(
			form.getFieldsValue(true),
			allPermissions,
			isAdmin
		);
				console.log("result:", result)

		setButtonLoader(true);
		UserMangementApis.editUser(currentUser.userId, result)
			.then((res) => {
				message.success("Update successful");
				closeModal(true);
				setButtonLoader(false);
			})
			.catch((e) => {
				Utils.ToastError(e);
			});
	};

	const getActionLabel = () => {
		if (modalType === "add" && headerTabKey === "2" && sideBarTabKey === "3") {
			return "Add user";
		}
		if (modalType === "add") {
			return "Next";
		}
		if (modalType === "edit" && headerTabKey === "1") {
			return "Next";
		}
		if (modalType === "edit" && headerTabKey === "2") {
			return "Save changes";
		}
	};

	return (
		<>
			<Modal
				visible={visible}
				onCancel={handleCancelModal}
				footer={null}
				centered
				width={750}
				bodyStyle={{
					padding: "2rem",
					height: 690,
					flexDirection: "column",
					display: "flex",
					justifyContent: "space-between",
				}}
				className="user-management"
			>
				<div>
					<ModalHeader
						handleTabChange={handleHeaderTabChange}
						modalType={modalType}
						headerTabKey={headerTabKey}
					/>
					<ModalSubHeader modalType={modalType} email={currentUser.email} />
					<div style={{ marginBottom: "1rem", marginTop: "1.3rem" }} />
				</div>
				<Form form={form} layout="vertical" style={{ height: "100%" }}>
					{renderbody()}
				</Form>
				<div>
					<LineBreak size={"1.5rem"} />
					<FooterButtons
						handleCancel={handleCancel}
						handleAction={handleAction}
						actionButtonLabel={getActionLabel()}
						cancelButtonLabel={headerTabKey === "1" ? "Cancel" : "Previous"}
						buttonLoader={buttonLoader || loading}
					/>
				</div>
			</Modal>
			{showCancelModal && (
				<CancelModal
					visible={showCancelModal}
					toggleCancelModal={toggleCancelModal}
					closeModal={closeModal}
				/>
			)}
		</>
	);
};

export default UserModal;
